import React, { useEffect } from 'react'
import { useParams } from 'react-router'
import { useHistory } from 'react-router-dom'
import { FLOW } from '../../config'
import { useAccount } from '../../hooks'
import usePharmacy from '../../hooks/pharmacy'
import { useAsync, useQuery } from '../../utils'

const PharmacyLogin = (props: any) => {
    const history = useHistory()
    const params: { pharmacistToken: string } = useParams()
    const query = useQuery()
    const flow = query.get('flow')
    const productSearchValue = query.get('productSearchValue')

    const { getPharmacistByToken } = usePharmacy()
    const { setFlowForApp } = useAccount()

    const getPharmacistByTokenAsync = useAsync(getPharmacistByToken)

    useEffect(() => {
        getPharmacistByTokenAsync.execute(params.pharmacistToken).then(res => {
            switch (flow) {
                case FLOW.PHARMACIST_FAST_UPDATE_INVENTORY: {
                    setFlowForApp(FLOW.PHARMACIST_FAST_UPDATE_INVENTORY)
                    history.push(`/search-product?productSearchValue=${productSearchValue}`)
                    break
                }
                case FLOW.DISTRIBUTOR: {
                    history.push(`/distributor-dashboard?tab=inventories`)
                    break
                }
                default: {
                    history.push('/inventory-dashboard?tab=inventories')
                    break;
                }
            }
        })
    }, [])

    return <></>
}

export default PharmacyLogin